import React from "react";
import FAQItem from "./FAQSingleComponent";
import { slugify } from "../../CommonFunctions";

interface FAQItemData {
  question: string;
  answer: React.ReactNode;
}

interface FAQSectionProps {
  sectionTitle: string;
  items: FAQItemData[];
  openId: string | null;
  toggleFAQ: (id: string) => void;
}

const FAQSection: React.FC<FAQSectionProps> = ({
  sectionTitle,
  items,
  openId,
  toggleFAQ,
}) => {
  return (
    <div className="faq-section">
      <h2>{sectionTitle}</h2>
      {items.map((item) => {
        const id = slugify(item.question);
        return (
          <FAQItem
            key={id}
            id={id}
            question={item.question}
            answer={item.answer}
            isOpen={openId === id}
            onClick={() => toggleFAQ(id)}
          />
        );
      })}
    </div>
  );
};

export default FAQSection;
